import axios from "axios";
import { Todo } from "@/components/todo-card/TodoCard.tsx";
import { getApiUrl } from "@/config/api";

axios.interceptors.request.use(config => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
    res => res,
    async err => {
      const originalRequest = err.config;

      if (err.response?.status === 401 && !originalRequest._retry && originalRequest.url !== 'api/auth/refresh') {
        originalRequest._retry = true;
        const success = await refreshAccessToken();
        if (success) {
          return axios(originalRequest); // повторяем запрос
        }
      }

      return Promise.reject(err);
    }
);

async function refreshAccessToken() {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return false;

  try {
    const res = await axios.post("api/auth/refresh", { refreshToken });
    const { accessToken } = res.data;
    localStorage.setItem("accessToken", accessToken);
    return true;
  } catch {
    return false;
  }
}

export namespace TodoService {
  
  export async function getTodos(): Promise<Todo[]> {
    const response = await axios.get(getApiUrl("todos"));
    return response.data as Todo[];
  }

  export async function updateTodo(todo: Todo): Promise<void> {
    await axios.put(getApiUrl("todos", todo.id), todo);
  }

  export async function createTodo(todo: Todo): Promise<Todo> {
    const response = await axios.post(getApiUrl("todos"), todo);
    return response.data as Todo;
  }

  export async function deleteTodo(id: number): Promise<void> {
    await axios.delete(getApiUrl("todos", id));
  }
}
